var map = {
	"./autocomplete": "c3pS",
	"./autocomplete/": "c3pS",
	"./autocomplete/handlers": "k8c5",
	"./autocomplete/handlers.ts": "k8c5",
	"./autocomplete/index": "c3pS",
	"./autocomplete/index.ts": "c3pS",
	"./content": "sQLV",
	"./content/": "sQLV",
	"./content/index": "sQLV",
	"./content/index.ts": "sQLV",
	"./create": "FgcQ",
	"./create.ts": "FgcQ",
	"./custom": "Y70t",
	"./custom/": "Y70t",
	"./custom/index": "Y70t",
	"./custom/index.ts": "Y70t",
	"./recommendation": "s5RT",
	"./recommendation/": "s5RT",
	"./recommendation/index": "s5RT",
	"./recommendation/index.ts": "s5RT",
	"./recommendation/payload": "v7cu",
	"./recommendation/payload.ts": "v7cu",
	"./search": "saiO",
	"./search/": "saiO",
	"./search/index": "saiO",
	"./search/index.ts": "saiO",
	"./smart-collection": "tZwI",
	"./smart-collection/": "tZwI",
	"./smart-collection/index": "tZwI",
	"./smart-collection/index.ts": "tZwI",
	"./tabs": "sor5",
	"./tabs/": "sor5",
	"./tabs/index": "sor5",
	"./tabs/index.ts": "sor5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vRk2";